// #======================================#
// #     _____       _ _       _  _       #
// #    |  __ \     (_) |     | || |      #
// #    | |__) |__ _ _| |___  | || |_     #
// #    |  _  // _` | | / __| |__   _|    #
// #    | | \ \ (_| | | \__ \    | |      #
// #    |_|  \_\__,_|_|_|___/    |_|      #
// #                                      #
// #======================================#

/*jslint */
/*global define */
define('DeviceChecks', function() {
  function iOS() {
    return (
      (/iphone|ipod|ipad/gi).test(navigator.appVersion)
    );
  }
  function iPad() {
    return (
      (/ipad/gi).test(navigator.appVersion)
    );
  }
  function android() {
    return (
      (/android/gi).test(navigator.appVersion)
    );
  }
  return {
    iOS: iOS,
    iPad: iPad,
    android: android
  };
});

define('HashBang', function() {
  // URL hash helper
  // URLs should not be crawlable:
  // https://developers.google.com/webmasters/ajax-crawling/docs/getting-started
  var split_parts = '/';
  var split_val = ':';
  function getParams() {
    var params = [];
    var parts = document.location.hash.replace('#', '').split(split_parts);
    for (var i=0, len=parts.length; i<len; i++) {
      var part = parts[i].split(split_val);
      if (part.length > 1) {
        params[part[0]] = part[1];
      }
    }
    return params;
  }
  function set(key, val) {
    if (history && history.pushState) {
      var params = getParams();
      if (val !== undefined && val !== null) {
        params[key] = escape(val);
      } else {
        params[key] = val;
      }
      var new_hash = '';
      var i = 0;
      for (var k in params) {
        if (params[k] !== undefined && params[k] !== null && params[k] !== '') {
          if (i > 0) {
            new_hash = new_hash + split_parts;
          }
          new_hash = new_hash + k + split_val + params[k];
          i++;
        }
      }
      if (new_hash) {
        history.pushState(null, null, '#'+new_hash);
      } else {
        history.pushState('', document.title, window.location.pathname + window.location.search);
      }
    }
  }
  function get(key) {
    var params = getParams();
    value = params[key];
    if (value !== undefined && value !== null) {
      return unescape(value);
    } else {
      return value;
    }
  }
  return {
    getParams : getParams,
    get : get,
    set: set
  };
});

define('CWCookie', function() {
  function CWCookie() {
  }

  CWCookie.cookie_domain = function() {
    var re = /catawiki\.([a-z.]+)/;
    // Test cookie domain
    if (location.hostname == '127.0.0.1') {
      return '127.0.0.1';
    } else {
      return re.exec(location.href)[0];
    }
  };

  CWCookie.set_cookie = function(name, value, options) {
    options = $.extend({ path : '/', domain : this.cookie_domain() }, options || {});
    $.cookie(name, value, options);
  };

  CWCookie.get_cookie = function(name) {
    return $.cookie(name);
  };

  CWCookie.remove_cookie = function(name) {
    return $.removeCookie(name, { path: '/', domain : this.cookie_domain() });
  };

  return CWCookie;
});

define('CWPerformance',function () {
  function CWPerformance() {
    this.use_performance_api = (typeof(window.performance) != "undefined");
    this.use_performance_now = (this.use_performance_api && typeof(window.performance.now) != "undefined"); // IE 9 does not have this.
    this.enabled = (typeof(AUCTION_DEBUG) != "undefined");
  }

  CWPerformance.prototype.start = function () {
    if (!this.enabled) {
      return;
    }
    if (this.use_performance_now) {
      this.start_date = performance.now();
    }
    else {
      this.start_date = Date.now();
    }
    console.log("[PERFORMANCE] -------------- ",0);
  };
  CWPerformance.prototype.end = function () {
    if (!this.enabled) {
      return;
    }
    this.log("END ---------");
    if (this.use_performance_api){
      var arr = [
        "navigationStart"
        ,"unloadEventStart"
        ,"unloadEventEnd"
        ,"redirectStart"
        ,"redirectEnd"
        ,"fetchStart"
        ,"domainLookupStart"
        ,"domainLookupEnd"
        ,"connectStart"
        ,"connectEnd"
        ,"secureConnectionStart"
        ,"requestStart"
        ,"responseStart"
        ,"responseEnd"
        ,"domLoading"
        ,"domInteractive"
        ,"domContentLoadedEventStart"
        ,"domContentLoadedEventEnd"
        ,"domComplete"
        ,"loadEventStart"
        ,"loadEventEnd"
      ];
      var perfData = window.performance.timing;
      if (perfData) {
        for (var i=0;i<arr.length; i++) {
          if (perfData[arr[i]] != 0) {
            console.log("[PERFORMANCE] ---- "+arr[i]+" -----",perfData[arr[i]] - perfData.navigationStart );
          }
        }
      }
    }
  };
  CWPerformance.prototype.log = function (message) {
    if (!this.enabled) {
      return;
    }
    var end;
    if (this.use_performance_now) {
      end = performance.now();
    }
    else {
      end = Date.now();
    }
    console.log("[PERFORMANCE] ---- "+message,end - this.start_date);
  };
  return CWPerformance;
});

require('DeviceChecks')
.define("CWDeeplink",function (imports) {
  "use strict";

  var DeviceChecks = imports.DeviceChecks;

  function get_app_link_platform() {

    var ios_match = DeviceChecks.iOS();
    if (ios_match !== null ) {
      return "iOS";
    }
    var android_match = navigator.userAgent.match(/Android/)
    if (android_match) {
      return "Android";
    }
    return null;
  }

  function get_url(platform,link) {
    if (platform == 'iOS' && link.indexOf('CatawikiBidApp://') == 0 ) {
      return link
    }
    else if (platform == 'iOS' ) {
      return 'CatawikiBidApp://'+link
    }
    else if (platform == 'Android' && link.indexOf('intent://') == 0 ) {
      return link
    }
    else if (platform == 'Android' ) {
      return 'intent://'+link+"#Intent;scheme=CatawikiBidApp;package=com.catawiki2;end"
    }
  }



  /* opens the url in the app.
     but if the url is not supported stays on the same page.

     params:
     app_link : contains path or protocol://path to the linked page.  Both are supported because the Apple app banner needs the protocol.

  */
  function deeplink(app_link) {
    var app_link_platform = get_app_link_platform();
    if (app_link_platform === null) {
      return;
    }
    var url = get_url(app_link_platform,app_link)

    // note. this does not work on many browsers,
    // should happen server side.
    if (app_link_platform === 'Android') {
      window.location = url
    }
    // iframe.onload = function() {
    //      alert('onload of iframe')
    // }
    else {
      var iframe = document.createElement("iframe");
      iframe.style.border = "none";
      iframe.style.width = "1px";
      iframe.style.height = "1px";
      iframe.src = url ;
      document.body.appendChild(iframe);

    }
  }

  // exports
  return {
    deeplink : deeplink
  };
});
